const Backbone  = window.Backbone;

import SubjectParameters from '../../../../../business-objects/SubjectParameters';

const SubjectCollectionModel = Backbone.Model.extend({
    defaults() {
        return {
            subjectParameters  : new SubjectParameters(),
            subjects           : [],
            uniqueTitles       : 0
        };
    }
});

export default SubjectCollectionModel;
